"use strict";

import React from 'react';
import {  Switch, Route, Redirect } from 'react-router-dom';
import Register from './component/Register';
import Account from './component/Account';
import AccountProvider from "./provider/AccountProvider";
import { transitions, positions, Provider as AlertProvider } from 'react-alert'
import AlertTemplatePanels from "../component/AlertTemplatePanels";
import RegisterProvider from "./provider/RegisterProvider";

const index = () => {
    const options = {
        position: positions.TOP_RIGHT,
        timeout: 5000,
        offset: '1rem',
        transition: transitions.SCALE
    }

    return (
        <AlertProvider template={AlertTemplatePanels} {...options}>
            <AccountProvider>
                <div style={{paddingTop: '1rem',}}>
                    <Switch>
                        <Route exact path='/echeck/register' render={
                            (props)=><RegisterProvider><Register /></RegisterProvider>
                        }/>
                        <Redirect exact from="/echeck/accounts/" to="/echeck/accounts/echecks" />
                        <Route path='/echeck/accounts/' component={Account}/>
                    </Switch>
                </div>
            </AccountProvider>
        </AlertProvider>
    );
};

export default index;
